import { render } from "./culturalTax.vue?vue&type=template&id=18ac35b7&scoped=true"
import script from "./culturalTax.vue?vue&type=script&lang=js"
export * from "./culturalTax.vue?vue&type=script&lang=js"

import "./culturalTax.vue?vue&type=style&index=0&id=18ac35b7&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ac35b7"]])

export default __exports__